import { select } from "redux-saga/effects";

import { writeToLocalStorage } from "common/utilities/localStorage";
import { getUsedCoachmarks } from "domains/coachmarks/selectors";

export function* changeCoachmarkUsedStatusSaga() {
  const usedCoachmarks: ReturnType<typeof getUsedCoachmarks> = yield select(getUsedCoachmarks);
  writeToLocalStorage("COACHMARKS_VIEWED_ITEMS", usedCoachmarks);
}
